import { NumberFormatter } from '@/app/formatters/number/NumberFormatter';
import { getLanguageConfig } from '@/utils/languageDetector';
import { CurrencyFormatter } from './CurrencyFormatter';

export const numberFormatter = NumberFormatter.make(getLanguageConfig().locale);
export const currencyFormatter = new CurrencyFormatter(getLanguageConfig().locale);
